/**
 * Get the site URL from environment variables.
 * In production runtime, throws if NEXT_PUBLIC_SERVER_URL is not set.
 * In all other contexts (development, build phase, CLI tools like
 * `payload generate:types`, test runners), falls back to localhost:3000.
 */
export default function getSiteUrl(): string {
  const url = process.env.NEXT_PUBLIC_SERVER_URL
  if (url) return url

  // In production runtime (not build phase), the URL is required.
  // Next.js always sets NODE_ENV=production for production builds and runtime,
  // so this gate reliably catches misconfigured deployments while allowing
  // CLI tools (generate:types, migrations) and test runners to work without it.
  if (process.env.NODE_ENV === 'production' && process.env.NEXT_PHASE !== 'phase-production-build') {
    throw new Error('NEXT_PUBLIC_SERVER_URL is not set - this is required in production')
  }

  return 'http://localhost:3000'
}
